import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { BrandService } from '@modules/shared/services/brand.service';

/**
 * Reemplaza el prefijo de marca ('Tourbo') en los títulos de ruta por el nombre
 * de la marca activa. En dominios Tourbo es un no-op; en Flaptek convierte
 * 'Tourbo' -> 'Flaptek' y 'Tourbo | Ingreso' -> 'Flaptek | Ingreso' sin tener
 * que editar las ~40 rutas existentes.
 */
@Injectable({
  providedIn: 'root',
})
export class BrandTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly brand: BrandService,
  ) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const built = this.buildTitle(snapshot);
    const resolved =
      built == null
        ? this.brand.brandName
        : built.replace(/^Tourbo\b/, this.brand.brandName);
    this.title.setTitle(resolved);
  }
}
